import { COUNTRY } from "../utils/constants";

export type SupplyAndDemandScope = {
  scope: ScopeKey;
  name: string;
  title: string;
  subtitle: string;
  currentVacancyRate: string;
  rentalStockAvailable: string;
  population: string;
  rentalPopulation: string;
};

export type StatisticsSection = {
  title: string;
  description: string;
  rows: TableRow[];
};

export type SuburbInsightsResponse = {
  isValid: boolean;
  validationError: string;
  seoName: string;
  pageTitle: string;
  suburbDescription: {
    sectionTitle: string;
    html: string;
  };
  supplyAndDemand: Record<ScopeKey, SupplyAndDemandScope>;
  statistics: Record<StatsTabKey, StatisticsSection>;
};

export type TableRow = {
  label: string;
  house: string;
  townhouses?: string;
  units: string;
};
export type ScopeKey = "suburb" | "region" | "state";
export type StatsTabKey = "median" | "rental" | "sales";

export const ALLOWED_COUNTRIES = new Set([COUNTRY.AU, COUNTRY.NZ]);
export const SUBURB_COMPONENT_TYPES = new Set([
  "locality",
  "sublocality",
  "sublocality_level_1",
  "postal_town",
  "neighborhood",
]);

export const stripCountrySuffix = (value: string) => value.replace(/\s*\(NZ\)$/i, "").trim();
export type MetricCard = {
  label: string;
  value: string;
};
